import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { assetApi } from '@application/api/endpoints/asset-api';
import { uploadFileAction } from '@application/redux/actions/fileActions';
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import ManualEntryForm from '@ui/components/Forms/ManualEntryForm';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { setIsUpdateGrid } from '@application/redux/asset-specific-incidents/asset-incidents-slice';
const CreateEntryDialog = ({ isOpen, onClose, variant = 'add' }) => {
    const { t } = useTranslation();
    const pathname = window.location.pathname;
    const segments = pathname.split('/');
    const id = segments[segments.length - 1];
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { assetName } = useSelector((state) => state.systemDetail);
    const [selectedSystem, setSelectedSystem] = useState(null);
    const methods = useForm({
        defaultValues: {
            incidentDate: new Date(),
            score: 0,
            assetDetailId: id,
            systemId: '',
            description: '',
            imageName: '',
            imageUrl: '',
            licensePlate: '',
            location: '',
            assetName: assetName,
            isManuallyEntered: true,
            incidentTime: dayjs()
        },
        mode: 'onBlur'
    });
    const { reset } = methods;
    const handleCreateIncident = async (data) => {
        if (data.incidentDate) {
            var _date = new Date(data.incidentDate.getFullYear(), data.incidentDate.getMonth(), data.incidentDate.getDate());
            var time = dayjs(data.incidentTime).format('HH:mm:ss');
            var [hours, minutes, seconds] = time.split(':').map(Number);
            _date.setHours(hours);
            _date.setMinutes(minutes);
            _date.setSeconds(seconds);
            data.incidentDate = _date;
        }
        try {
            if (selectedFile && selectedFile[0].name) {
                var fileResponse = await dispatch(uploadFileAction('Images', selectedFile[0]));
                if (fileResponse) {
                    const { blob } = fileResponse;
                    data.imageName = blob.name;
                    data.imageUrl = selectedFile[0].name || '';
                }
            }
            var time = dayjs(data.incidentTime).format('HH:mm');
            const payload = {
                ...data,
                incidentTime: time
            };
            if (payload.systemId === '') {
                payload.systemId = null;
            }
            const response = await assetApi.createAssetIncident(payload);
            if (response.isSuccess) {
                toast.success(response.message);
                dispatch(setIsUpdateGrid());
                // dispatch(refreshProjects());
            }
            else {
                toast.error(response.message);
            }
        }
        catch (error) {
            toast.error(t('SomethingWentWrong'));
        }
        finally {
            if (onClose)
                onClose();
        }
    };
    const onSubmit = async (data) => {
        try {
            setLoading(true);
            await handleCreateIncident(data);
        }
        catch (error) {
            console.error('Error saving system:', error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleClose = () => {
        onClose();
        reset();
    };
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', PaperProps: {
            sx: {
                width: '564px'
            }
        }, fullWidth: true, "aria-labelledby": 'AssetDialog', onKeyDown: (e) => e.key === 'Enter' && {}, children: [_jsxs(DialogTitle, { id: 'manual-entry-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsxs(Typography, { variant: 'h6', color: 'text.primary', children: [variant === 'add' ? 'Add' : 'Edit', " Entry"] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(FormProvider, { ...methods, children: _jsx(ManualEntryForm, { setSelectedFile: setSelectedFile, id: id, setSelectedSystem: setSelectedSystem }) }) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: methods.handleSubmit(onSubmit), variant: 'contained', color: 'inherit', disabled: loading, children: t('Confirm') }), _jsx(Button, { onClick: handleClose, color: 'inherit', variant: 'outlined', children: t('Cancel') })] })] }));
};
export default CreateEntryDialog;
